export const validationYaml = () => `id: "||VARIABLE_KEY_id||"
index: "||VARIABLE_KEY_index||"
name: "||VARIABLE_KEY_name||"
description: ""
type: 
metadata: `;
export const validationTypesTemplate = () => [
  {
    type: 'BETWEEN',
    tags: ['between', 'betwen', 'ween', 'bet'],
    metadataSample: {
      field_name: 'qty',
      from_value: '0',
      to_value: '999',
      format: '<only_use_for_DateTime>',
      data_type: 'String|Numeric|DateTime|Boolean',
    },
  },
  {
    type: 'REGEX',
    tags: ['regex', 'regexp', 'reg'],
    metadataSample: {
      field_name: 'id',
      expression: '^[0-9]+$',
    },
  },
  {
    type: 'CONTAIN',
    tags: ['contain', 'contains', 'con', 'tain'],
    metadataSample: {
      field_name: 'product_name',
      value: 'non-stock',
      case_sensitive: false,
    },
  },
  {
    type: 'NOT_CONTAIN',
    tags: ['contain', 'contains', 'con', 'tain'],
    metadataSample: {
      field_name: 'product_name',
      value: 'non-stock',
      case_sensitive: false,
    },
  },
  {
    type: 'IS_EMPTY',
    tags: ['empt', 'empty', 'emp'],
    metadataSample: {
      field_name: 'inactive',
    },
  },
  {
    type: 'NOT_EMPTY',
    tags: ['empt', 'empty', 'emp'],
    metadataSample: {
      field_name: 'inactive',
    },
  },
  {
    type: 'END_WITH',
    tags: ['end', 'with', 'wth', '/w'],
    metadataSample: {
      field_name: 'product_name',
      value: '_inactive',
      case_sensitive: false,
    },
  },
  {
    type: 'NOT_END_WITH',
    tags: ['end', 'with', 'wth', '/wt', 'without'],
    metadataSample: {
      field_name: 'product_name',
      value: '_inactive',
      case_sensitive: false,
    },
  },
  {
    type: 'EQUAL',
    tags: ['eq', 'equal', 'equals'],
    metadataSample: {
      field_name: 'company_type',
      value: 'GLOBAL',
      case_sensitive: false,
      data_type: 'String|Numeric|DateTime|Boolean',
    },
  },
  {
    type: 'NOT_EQUAL',
    tags: ['eq', 'equal', 'equals'],
    metadataSample: {
      field_name: 'company_type',
      value: 'GLOBAL',
      case_sensitive: false,
      data_type: 'String|Numeric|DateTime|Boolean',
    },
  },
  {
    type: 'GREATER_THAN_OR_EQUAL',
    tags: ['gt', 'gteq', 'greater', 'great', 'eq', 'equal'],
    metadataSample: {
      field_name: 'qty',
      value: '0',
      format: '<only_use_for_DateTime>',
      data_type: 'String|Numeric|DateTime|Boolean',
    },
  },
  {
    type: 'GREATER_THAN',
    tags: ['gt', 'greater', 'great'],
    metadataSample: {
      field_name: 'qty',
      value: '0',
      format: '<only_use_for_DateTime>',
      data_type: 'String|Numeric|DateTime|Boolean',
    },
  },
  {
    type: 'LESS_THAN',
    tags: ['lt', 'less'],
    metadataSample: {
      field_name: 'qty',
      value: '0',
      format: '<only_use_for_DateTime>',
      data_type: 'String|Numeric|DateTime|Boolean',
    },
  },
  {
    type: 'LESS_THAN_OR_EQUAL',
    tags: ['lt', 'lteq', 'less', 'eq', 'equal'],
    metadataSample: {
      field_name: 'qty',
      value: '0',
      format: '<only_use_for_DateTime>',
      data_type: 'String|Numeric|DateTime|Boolean',
    },
  },
  {
    type: 'IN',
    tags: ['in'],
    metadataSample: {
      field_name: 'qty',
      values: ['1', '2'],
      case_sensitive: false,
      data_type: 'String|Numeric|DateTime|Boolean',
    },
  },
  {
    type: 'NOT_IN',
    tags: ['in'],
    metadataSample: {
      field_name: 'qty',
      values: ['1', '2'],
      case_sensitive: false,
      data_type: 'String|Numeric|DateTime|Boolean',
    },
  },
  {
    type: 'LENGTH',
    tags: ['len', 'lent', 'leng', 'length'],
    metadataSample: {
      field_name: 'qty',
      value: 16,
    },
  },
  {
    type: 'MAX_LENGTH',
    tags: ['len', 'lent', 'leng', 'length'],
    metadataSample: {
      field_name: 'qty',
      value: 16,
    },
  },
  {
    type: 'MIN_LENGTH',
    tags: ['len', 'lent', 'leng', 'length'],
    metadataSample: {
      field_name: 'qty',
      value: 16,
    },
  },
  {
    type: 'IS_NULL',
    tags: ['nil', 'null', 'empty', 'empt'],
    metadataSample: {
      field_name: 'qty',
    },
  },
  {
    type: 'NOT_NULL',
    tags: ['nil', 'null', 'empty', 'empt'],
    metadataSample: {
      field_name: 'qty',
    },
  },
  {
    type: 'START_WITH',
    tags: ['start', 'with'],
    metadataSample: {
      field_name: 'brand_name',
      value: 'INTERNATIONAL',
      case_sensitive: false,
    },
  },
  {
    type: 'NOT_START_WITH',
    tags: ['start', 'with'],
    metadataSample: {
      field_name: 'brand_name',
      value: 'INTERNATIONAL',
      case_sensitive: false,
    },
  },
];
